
import { Tree, TreeNode } from 'react-organizational-chart';

const TeamTree = props => {
	const { type, values, touched, errors } = props

	function maskString(str) {
		console.log(str)
		const firstChar = str.charAt(0);
		//const lastChar = str.charAt(str.length - 1);
		//const middle = str.slice(1, -1).replace(/./g, '*');
		const middle = str.slice(1, 4).replace(/./g, '*');
		const lastChar = str.slice(4)
		return firstChar + middle + lastChar;
	}

	const StyledNode = ({ children }) => <span>{children}</span>;

	// 構建樹狀結構的遞迴函式
	const buildTree = (data) => {
		console.log(data);
		if (!data) {
			return
		}
		// data.forEach(item => {
		// 	let mailname = item.email.split("@")
		// 	item.email = maskString(mailname[0]) +"@"+ mailname[1]	
		// });

		return data.map((item, index) => {
			const label = <StyledNode>
				<div>
					<strong>{item.name}</strong>
					<p className='text-xs font-bold'>{item.phone}</p>
				</div>
			</StyledNode>;
			const children = item.teamMember && item.teamMember.length > 0 ? buildTree(item.teamMember) : null;

			return (
				<TreeNode key={index} label={label}>
					{children}
				</TreeNode>
			);
		});
	};


	return (
		<div className="mb-4 text-main" divider>


			<Tree
				lineWidth={'2px'}
				lineColor={'#E0836F'}
				lineBorderRadius={'10px'}
				label={<StyledNode><strong> {values.name}</strong></StyledNode>}
			>
				{buildTree(values.teamMember)}
			</Tree>
		</div>
	)
}

export default TeamTree